export const getEmployee = (employeeId) => ({ employees: { employeesList } }) =>
  employeesList.find(({ id }) => id === +employeeId);
